var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8","lg":"8"}},[_c('CreateUserForm',{attrs:{"types":_vm.types}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }